import { getTranslation } from 'helpers/getTranslation';

import type { CuratorReportCourseProgressChart } from '../../SchoolCuratorReportPage.helpers';

export const getProgressChartTabLabel = (
  chart: CuratorReportCourseProgressChart,
) => {
  if (chart.id === 'all') {
    return getTranslation(
      'school_curator_report_page.progress_chart.all_courses',
    );
  }

  return chart.title;
};

export const getProgressChartLineData = (
  chart: CuratorReportCourseProgressChart,
) => [
  {
    id: 'students',
    color: '#1182f6',
    data: chart.progressDistribution.map((bucket) => ({
      x: bucket.progress,
      y: bucket.count,
    })),
  },
];

export const hasProgressChartData = (
  chart: CuratorReportCourseProgressChart,
) => chart.progressDistribution.some((bucket) => bucket.count > 0);
